import { graphql } from "lib/generated/app-service-gql";
import { CompanyDocumentLabelsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const COMPANY_DOCUMENT_LABELS_QUERY = graphql(`
  query companyDocumentLabels {
    companyDocumentLabels {
      labels
    }
  }
`);

export function useCompanyDocumentLabels() {
  const { data, ...rest } = useGraphQlQuery<CompanyDocumentLabelsQuery>(
    ["companyDocumentLabels"],
    COMPANY_DOCUMENT_LABELS_QUERY,
    [{}],
    REACT_QUERY_OPTIONS_NEVER_REFETCH,
  );

  return {
    labels: data?.companyDocumentLabels.labels ?? [],
    ...rest,
  };
}
